module.exports = __webpack_public_path__ + "img/rongyu.c2398d4e.jpg";